import {
  Avatar,
  Box,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { EditEnterpriseMemberRole } from "../Modal/UpdateEnterpriseMemberRole";
import { styles } from "../../pages/TeamManagement/styles";
import { useContext } from "react";
import { UserDetailsContext } from "../../contexts";
import { getRoleString } from "../../pages/Projects/types";
import { getTimestampToDate } from "../../pages/TeamManagement/TeamManagementHandler";
import DeleteIcon from "@mui/icons-material/Delete";
import { Role } from "../../proto/api_pb";
import { TeamManagementTableProps } from "./types";

export const TeamManagementTable: React.FC<TeamManagementTableProps> = ({
  teamMembers,
  setSelectedEmailToDelete,
  setIsConfirmationModalOpen,
  getTeamMembers,
  currentUser,
  isLoading,
}) => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const { enterprise } = useContext(UserDetailsContext);
  return (
    <>
      <Box sx={styles.scrollContainer}>
        <Box
          sx={{
            ...styles.th,
            width: isSmallScreen ? "1200px" : "auto",
          }}
        >
          <Box sx={{ width: "50%" }}>Name</Box>
          <Box>Role</Box>
          <Box sx={{ marginLeft: 4 }}>Date Added</Box>
          <Box sx={{ marginLeft: -1 }}>Last Active</Box>
          <Box sx={{ width: "80px" }}></Box>
        </Box>
        {teamMembers.map((m, i) => {
          const enterpriseDetails = m
            .getEnterpriseDetailsList()
            .find((ed) => ed.getEnterpriseId() === enterprise?.id);
          return (
            <Box
              key={i}
              sx={{
                ...styles.tableRow,
                width: isSmallScreen ? "1200px" : "auto",
                background:
                  m.getUsername().includes("dummy_ommuse") ||
                  m.getUsername() === ""
                    ? "linear-gradient(109deg, #CC5433 -80.71%, rgba(204, 84, 51, 0.13) 36.11%, rgba(204, 84, 51, 0.00) 62.63%)"
                    : "",
              }}
            >
              <Box sx={{ width: "50%", display: "flex" }}>
                <Avatar alt="Sharp" src={m.getProfilePicture()} />
                <Box sx={{ marginLeft: "15px" }}>
                  <Typography sx={{ fontWeight: "bold", color: "white" }}>
                    {m.getUsername().includes("dummy_ommuse")
                      ? "Invitation Pending"
                      : m.getUsername()}
                  </Typography>
                  <Typography>{m.getEmail()}</Typography>
                </Box>
              </Box>
              <Box sx={styles.roleContainer}>
                {getRoleString(Number(enterpriseDetails?.getRole()))}
              </Box>
              <Box sx={styles.dAddedContainer}>
                {getTimestampToDate(enterpriseDetails?.getDateAdded() ?? 0)}
              </Box>
              <Box sx={styles.lastActiveContainer}>
                {m.getUsername().includes("dummy_ommuse") ||
                m.getUsername() === ""
                  ? "-----"
                  : getTimestampToDate(enterpriseDetails?.getLastActive() ?? 0)}
              </Box>
              <Box sx={styles.controlsContainer}>
                {m.getUsername() !== "" ? (
                  <>
                    {Number(enterprise?.role) !== Role.ROLE_ARTIST && (
                      <Tooltip placement="top" title="Delete Member">
                        <IconButton
                          onClick={() => {
                            setSelectedEmailToDelete(m.getEmail());
                            setIsConfirmationModalOpen(true);
                          }}
                        >
                          <DeleteIcon style={{ color: "#94969C" }} />
                        </IconButton>
                      </Tooltip>
                    )}
                    {Number(enterprise?.role) !== Role.ROLE_ARTIST && (
                      <EditEnterpriseMemberRole
                        member={m}
                        getTeamMembers={getTeamMembers}
                        enterpriseDetails={enterpriseDetails}
                        currentUser={currentUser}
                      />
                    )}
                  </>
                ) : (
                  <Box sx={styles.emptySpace} />
                )}
              </Box>
            </Box>
          );
        })}
        {isLoading && (
          <Box sx={styles.loadingContainer}>
            <CircularProgress />
          </Box>
        )}
      </Box>
    </>
  );
};
